import logo1 from "img/logo1.png";
import logo2 from "img/logo2.png";
import logo3 from "img/logo3.png";

import "./logos.scss";

export default function Logos() {
   return (
      <div className="logos">
         <img src={ logo1 }/>
         <img src={ logo2 }/>
         <img src={ logo3 }/>
      </div>
   )
}